import { useEffect, useState } from 'react';

export function useStaggeredEnable(delayMs: number): boolean {
	const [isEnabled, setIsEnabled] = useState(delayMs <= 0);

	useEffect(() => {
		if (delayMs <= 0) {
			setIsEnabled(true);
			return undefined;
		}

		const timer = window.setTimeout(() => setIsEnabled(true), delayMs);
		return () => clearTimeout(timer);
	}, [delayMs]);

	return isEnabled;
}
